var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import designTokens from '@customink/design-tokens/build/ci_light/js/designTokens';
var themeOptions = function (theme) { return ({
    components: {
        MuiButton: {
            defaultProps: {
                variant: 'contained',
                color: 'blue',
                disableElevation: true,
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    fontWeight: 600,
                    fontSize: '14px',
                    lineHeight: 1.3,
                    height: '40px',
                    padding: "8px ".concat(designTokens.spacing[16].value),
                    textTransform: 'none',
                },
                sizeLarge: {
                    fontSize: '16px',
                    lineHeight: 1.35,
                    height: '48px',
                    paddingBottom: '10px',
                    paddingTop: '10px',
                },
                sizeSmall: {
                    fontSize: '12px',
                    lineHeight: 1.35,
                    height: '32px',
                    paddingBottom: '6px',
                    paddingTop: '6px',
                },
                text: {
                    '&:hover': {
                        backgroundColor: 'unset',
                    },
                },
                iconSizeSmall: {
                    '& > *:first-of-type': {
                        fontSize: designTokens.typographyLegacy.icon.small.size.value,
                    },
                },
                iconSizeMedium: {
                    '& > *:first-of-type': {
                        fontSize: designTokens.typographyLegacy.icon.medium.size.value,
                    },
                },
                iconSizeLarge: {
                    '& > *:first-of-type': {
                        fontSize: designTokens.typographyLegacy.icon.large.size.value,
                    },
                },
            },
            variants: __spreadArray(__spreadArray([], ['red', 'blue'].map(function (color) { return ({
                // {variant: 'primary'} and {variant: 'tertiary'} in Pigment API
                props: { color: color, variant: 'contained' },
                style: {
                    // Explicitely stating all selectors for backwards compatibility of Pigment
                    //  with apps that use stylebitz (sb defines some of these globally and needs to be overriden)
                    '&:visited, &:link': {
                        backgroundColor: designTokens.color[color].default.value,
                        color: designTokens.color.shade.white.value,
                    },
                    '&:hover': {
                        backgroundColor: designTokens.color[color].hover.value,
                        color: designTokens.color.shade.white.value,
                    },
                    '&:active': {
                        backgroundColor: designTokens.color[color].active.value,
                        color: designTokens.color.shade.white.value,
                    },
                    '&:focus-visible': {
                        backgroundColor: theme.palette[color].light,
                        color: designTokens.color.shade.white.value,
                    },
                },
            }); }), true), [
                {
                    // {variant: 'secondary'} in Pigment API
                    props: { color: 'blue', variant: 'outlined' },
                    style: {
                        border: "1px solid ".concat(designTokens.color.blue.default.value),
                        backgroundColor: designTokens.color.shade.white.value,
                        '&:focus-visible': {
                            backgroundColor: theme.palette.blue.light,
                            color: theme.palette.blue.contrastText,
                        },
                        '&:hover': {
                            backgroundColor: designTokens.color.blue.hover.value,
                            borderColor: designTokens.color.blue.hover.value,
                            color: theme.palette.blue.contrastText,
                        },
                        '&:active': {
                            backgroundColor: designTokens.color.blue.active.value,
                            borderColor: designTokens.color.blue.active.value,
                            color: theme.palette.blue.contrastText,
                        },
                    },
                },
                {
                    // {variant: 'link'} in Pigment API
                    props: { color: 'blue', variant: 'text' },
                    style: {
                        paddingLeft: theme.spacing(1),
                        paddingRight: theme.spacing(1),
                        minWidth: 'unset',
                        '&:hover, &:focus': {
                            backgroundColor: designTokens.color.blue.default.alpha.hover.value,
                        },
                        '&:active': {
                            backgroundColor: designTokens.color.blue.default.alpha.active.value,
                        },
                        '&:focus-visible': {
                            color: theme.palette.blue.light,
                            textDecoration: 'underline',
                            textUnderlineOffset: 2,
                        },
                    },
                },
            ], false),
        },
    },
}); };
export default themeOptions;
//# sourceMappingURL=buttonTheme.js.map